import { jsx as _jsx } from "preact/jsx-runtime";
import { clsx } from 'clsx';
function FormGroup(props) {
    const { children, className, ...attrs } = props;
    const finalClassName = clsx('form__group', className);
    return (_jsx("div", { ...attrs, className: finalClassName, children: children }));
}
export default FormGroup;
